import AbstractRange from "@/core/types/AbstractRange";
import TimeStamp      from "@/core/types/TimeStamp";

/**
 * Диапазон дат со временем
 */
class DateTimeRange extends AbstractRange<TimeStamp> {
  constructor(start: TimeStamp | Date | string | number | null = null, end: TimeStamp | Date | string | number | null = null) {
    // Конвертируем в TimeStamp если нужно
    const convertedStart = start ? (start instanceof TimeStamp ? start : new TimeStamp(start)) : null;
    const convertedEnd = end ? (end instanceof TimeStamp ? end : new TimeStamp(end)) : null;

    super(convertedStart, convertedEnd);
  }

  static fromServer(dateTimeRangeData: any, result = new DateTimeRange()) {
      return new DateTimeRange(
          TimeStamp.fromServer(dateTimeRangeData.start),
          TimeStamp.fromServer(dateTimeRangeData.end)
      )
  }

  /**
   * Возвращает продолжительность в миллисекундах
   */
  getDuration(): number {
    if (this.isEmpty()) {
      return 0;
    }
    return this._end!.getTime() - this._start!.getTime();
  }

  /**
   * Возвращает продолжительность в минутах
   */
  getDurationInMinutes(): number {
    return Math.floor(this.getDuration() / (1000 * 60));
  }

  /**
   * Возвращает продолжительность в часах
   */
  getDurationInHours(): number {
    return Math.floor(this.getDuration() / (1000 * 60 * 60));
  }
}

export default DateTimeRange;
